import { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Grid, Typography, Button } from '@material-ui/core'
import { Home as HomeIcon } from '@material-ui/icons'
import Item  from './Item'
import axios from 'axios'
import { StateContext, DispatchContext } from 'context/Provider'

import './styles.css'

const Announcements = () => {
    const appState = useContext(StateContext)
    const { authState } = appState

    const appDispatch = useContext(DispatchContext)
    const { globalDispatch } = appDispatch

    const [announcements, setAnnouncements] = useState([])

    const getAnnouncements = async () => {
        try {
            const axiosInstance = axios.create({
                baseURL: `https://${authState.user.sms_subdomain}.academeportal.com/api/`
            })

            axiosInstance.CancelToken = axios.CancelToken;
            axiosInstance.isCancel = axios.isCancel;

            const response = await axiosInstance.get('announcements')

            setAnnouncements(response.data)
        } catch (e) {
            console.log(e)
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {
        globalDispatch({type: 'setIsLoading', value: true});
        getAnnouncements()
        globalDispatch({type: 'setShowTabs', value: false})
    }, [])

    return (
        <ResponsiveLayout>
            <Grid container justify='center'>
                <Grid id="banner" item container md={8}>
                    <Grid id="announcement" item>
                        <img src="/images/announcement.svg" alt="Announcement" />
                    </Grid>
                    <Grid id="header" item>
                        <Typography variant="h4" component="h1">{authState.user.school_name}</Typography>
                        <Typography variant="h6" component="h3">Official Bulletin Board</Typography>
                    </Grid>
                    <Grid id="actions" item>
                        <Link to="/dashboard">
                            <Button variant="outlined" color="primary" startIcon={<HomeIcon />}>
                                Go to my classes
                            </Button>
                        </Link>
                    </Grid>
                </Grid>
                <Grid item md={8} lg={8} xl={8}>
                    { announcements.map((announcement) => (
                        <Item key={announcement.id} announcement={announcement} />
                    )) }

                    { announcements.length === 0 && <div id="empty-announcement">
                        <img src="/images/empty-board.svg" alt="Empty Board" />
                        <Typography variant="h4" component="h1">No announcement yet</Typography>
                    </div> }
                </Grid>
            </Grid>
        </ResponsiveLayout>
    )
}

export default Announcements;